import { Fragment, useEffect, useState } from "react";
import { dynamicImage, Image } from "../Utils";

const Loader = () => {
  const [show, setShow] = useState(true);
  useEffect(() => {
    const timeout = setTimeout(() => setShow(false), 1000);
    return () => clearTimeout(timeout);
  }, [show]);
  return (
    <Fragment>
      {show && (
        <div className="chatzy-loader">
          <div>
            <Image src={dynamicImage("logo/logo_big.png")} alt="loader" />
            <h3>{"Simple, secure messaging for fast connect to world..!"}</h3>
          </div>
        </div>
      )}
    </Fragment>
  );
};

export default Loader;
